import React from "react";

import mobileNetworkSectionImage from "../../../assets/mobileNetworkSection.png";


import "./networkSection.css"

const NetworkSection = () => {
  return (
    <div className="mobileNetworkSection-container">
      <img
        src={mobileNetworkSectionImage}
        className="mobileNetworkSection-image"
      />

      <div className="mobileNetworkSection-content">
        <div className="mb-networkSection-title">
          Learn, Network, Empower & Grow
        </div>
        <div className="mb-networkSection-content">
          Classplus in association with Anant Laddha (Founder, Invest Aaj For
          Kal) invites you to FinClave 2022, a meet-n-greet exclusively for the
          finance content creators of India. <br />
          <br />
          True heroes don't wear capes, they educate and empower the masses
          about financial freedom! <br />
          <br />
          That’s why! We are keen on CELEBRATING our very own Finfluencers!{" "}
          <br />
          <br />
          Build deeper relationships, collaborate, inspire, and get inspired!{" "}
          <br />
          <br />
          COUNT ME IN!
        </div>
      </div>
    </div>
  );
};

export default NetworkSection;
